var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

import React, { Component } from 'react';
import { fetchHeaders, sortArrayCompareFunction, chartColors, emptyChart } from './chartUtils';
import { Line, Bar } from 'react-chartjs-2';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import '../../styles/priceAnalysis.css';
import '../../styles/charts.css';
import cloneDeep from 'lodash/cloneDeep';
import { Button, shapes } from '@cimpress/react-components';
import 'chartjs-plugin-zoom';

var PriceAnalysis =
/** @class */
function (_super) {
  __extends(PriceAnalysis, _super);

  function PriceAnalysis(props) {
    var _this = _super.call(this, props) || this;

    _this.getInitialState = function () {
      return {
        priceAnalysisChartType: 'bar',
        chartData: null,
        areaChartData: null,
        selectedContract: null,
        contracts: null,
        barChartData: null,
        showSpinner: true
      };
    };

    _this.changePriceUnit = function (priceMode) {
      var _a = _this.state,
          chartData = _a.chartData,
          selectedContract = _a.selectedContract,
          areaChartData = _a.areaChartData,
          barChartData = _a.barChartData;
      var labels = chartData.labels;

      if (priceMode === 'unit') {
        var areaDatasets = cloneDeep(areaChartData).datasets;
        var noOfValues = areaDatasets[0].data.length;

        for (var i = 0; i < noOfValues; i++) {
          for (var j = 0; j < 3; j++) {
            if (areaDatasets[j].data[i] && areaDatasets[j].label !== 'Current Selection') {
              areaDatasets[j].data[i] /= parseInt(labels[i], 10);
            }
          }
        }

        var updatedAreaChartData = {
          labels: labels,
          datasets: areaDatasets
        };
        var barDatasets = cloneDeep(barChartData).datasets;
        noOfValues = barDatasets[0].data.length;

        for (var i = 0; i < noOfValues; i++) {
          for (var j = 0; j < 2; j++) {
            if (barDatasets[j].data[i] && barDatasets[j].label !== 'Current Selection') {
              barDatasets[j].data[i][0] /= parseInt(labels[i], 10);
              barDatasets[j].data[i][1] /= parseInt(labels[i], 10);
            }
          }
        }

        var updatedBarChartData = {
          labels: labels,
          datasets: barDatasets
        };

        _this.setState({
          areaChartData: updatedAreaChartData,
          barChartData: updatedBarChartData
        });
      } else {
        var result = _this.filterChartDatafromDataset(chartData, selectedContract);

        _this.setState({
          areaChartData: result.areaChartData,
          barChartData: result.barChartData
        });
      }
    };

    _this.filterChartDatafromDataset = function (chartData, selectedContract) {
      var labels = chartData.labels,
          datasets = chartData.datasets;
      var rows = Object.values(datasets[selectedContract.toLowerCase()]);
      var areaData = [];
      var barData = [];
      rows.forEach(function (data) {
        if (data.label === 'Price Range') {
          data.order = 2;
          barData.push(data);
        } else if (data.label === 'Current Selection') {
          areaData.push(data);
          data.type = 'line';
          data.order = 1;
          barData.push(data);
        } else {
          areaData.push(data);
        }
      });
      var areaChartData = {
        labels: labels,
        datasets: areaData
      };
      var barChartData = {
        labels: labels,
        datasets: barData
      };
      return {
        areaChartData: areaChartData,
        barChartData: barChartData
      };
    };

    _this.populateGraphData = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, gridData, headers, pivotKeyRow, pivotKeyColumn, priceMode, priceRangeResults, colors, colorIndex, currentSelectionQuantities, contracts, currentSelectionDataset, sortedContracts, priceRangeDataset, priceRangeQuantities, selectedContract, labels, result, chartData, areaChartData, barChartData, chartData;

        var _this = this;

        return __generator(this, function (_b) {
          _a = this.props, gridData = _a.gridData, headers = _a.headers, pivotKeyRow = _a.pivotKeyRow, pivotKeyColumn = _a.pivotKeyColumn, priceMode = _a.priceMode, priceRangeResults = _a.priceRangeResults;
          colors = Object.values(chartColors);
          colorIndex = -1;
          currentSelectionQuantities = [];
          contracts = {};
          currentSelectionDataset = {};

          if (!gridData || !headers) {
            this.setState({
              showSpinner: false
            });
            return [2
            /*return*/
            , null];
          }

          headers.forEach(function (columndDef) {
            if (columndDef.headerName !== pivotKeyRow) {
              var result_1 = fetchHeaders(columndDef);
              result_1.forEach(function (header) {
                colorIndex += 1;
                var key = header.split('|').filter(function (head) {
                  return head !== '';
                }).pop();
                currentSelectionDataset[key.toLowerCase()] = {
                  label: key,
                  backgroundColor: colors[colorIndex % 12],
                  borderColor: colors[colorIndex % 12],
                  data: {},
                  currency: {},
                  fill: false
                };
              });
            }
          });
          colorIndex = -1;
          gridData.forEach(function (row) {
            var keys = Object.keys(row); // If data is available in row

            if (keys.length > 1) {
              keys.forEach(function (data) {
                if (data.toLowerCase() !== pivotKeyRow.toLowerCase()) {
                  var displayPrice = row[data].productPrice && row[data].productPrice.displayPrice || undefined;
                  var currency = row[data].productPrice && row[data].productPrice.currency || undefined;
                  var quantity = row[data].quantity;

                  if (quantity) {
                    currentSelectionQuantities.push(quantity);

                    _this.insertPrices(data, quantity, currentSelectionDataset, pivotKeyColumn, contracts, displayPrice, currency);
                  }
                }
              });
            }
          }); // Remove duplicate quantities

          currentSelectionQuantities = new Set(currentSelectionQuantities);
          contracts = Object.values(contracts);
          sortedContracts = this.sortContracts(contracts);
          contracts = __spread(sortedContracts.CatalogPrice, sortedContracts.Contracts);
          priceRangeDataset = {};

          if (!priceRangeResults || Object.keys(priceRangeResults).length === 0) {
            this.setState({
              showSpinner: false
            });
            return [2
            /*return*/
            , null];
          }

          priceRangeQuantities = [];
          contracts = contracts.filter(function (contract) {
            return Object.keys(priceRangeResults).includes(contract.toLowerCase());
          });
          selectedContract = contracts[0];
          contracts.forEach(function (contract) {
            var normalizedContractName = contract.toLowerCase();
            var priceDataArray = priceRangeResults[normalizedContractName];

            if (!priceRangeDataset[normalizedContractName]) {
              priceRangeDataset[normalizedContractName] = {
                minimum: {
                  label: 'Minimum',
                  data: {},
                  currency: {},
                  fill: '1',
                  borderWidth: '1',
                  backgroundColor: 'rgba(32, 162, 224, 0.3)',
                  borderColor: 'rgba(32, 162, 224, 0.3)'
                },
                maximum: {
                  label: 'Maximum',
                  backgroundColor: 'rgba(32, 162, 219, 0.3)',
                  borderColor: 'rgba(32, 162, 219, 0.3)',
                  borderWidth: '1',
                  data: {},
                  currency: {},
                  fill: false
                },
                minmax: {
                  label: 'Price Range',
                  backgroundColor: 'rgb(249,255,212)',
                  borderColor: 'rgb(255,234,203)',
                  borderWidth: '1',
                  data: {},
                  currency: {},
                  fill: false
                },
                current: {
                  label: 'Current Selection',
                  backgroundColor: 'rgb(104,120,97)',
                  borderColor: 'rgb(104,120,97)',
                  borderWidth: '1',
                  data: {},
                  currency: {},
                  fill: false
                }
              };
            }

            priceDataArray.forEach(function (row) {
              var quantity = row.quantity;
              priceRangeQuantities.push(quantity);
              var min = row.min,
                  max = row.max;
              var minAmount;
              var minAmountCurrency;
              var maxAmount;
              var maxAmountCurrency;

              if (min && min.price) {
                minAmount = min.price.amount;
                minAmountCurrency = min.price.currency;
              }

              if (max && max.price) {
                maxAmount = max.price.amount;
                maxAmountCurrency = max.price.currency;
              }

              priceRangeDataset[normalizedContractName].minmax.data[quantity] = [minAmount, maxAmount];
              priceRangeDataset[normalizedContractName].minmax.currency[quantity] = minAmountCurrency || maxAmountCurrency;
              priceRangeDataset[normalizedContractName].minimum.data[quantity] = minAmount;
              priceRangeDataset[normalizedContractName].minimum.currency[quantity] = minAmountCurrency;
              priceRangeDataset[normalizedContractName].maximum.data[quantity] = maxAmount;
              priceRangeDataset[normalizedContractName].maximum.currency[quantity] = maxAmountCurrency;
            });
          });
          priceRangeQuantities = new Set(priceRangeQuantities);
          labels = this.mergeCurrentSelectionWithPriceRangeDataset(currentSelectionQuantities, currentSelectionDataset, priceRangeQuantities, priceRangeDataset, contracts);

          if (selectedContract) {
            chartData = {
              labels: labels,
              datasets: priceRangeDataset
            };
            result = this.filterChartDatafromDataset(chartData, selectedContract);
            areaChartData = result.areaChartData;
            barChartData = result.barChartData;
            this.setState({
              areaChartData: areaChartData,
              barChartData: barChartData,
              chartData: chartData,
              contracts: contracts,
              selectedContract: selectedContract,
              showSpinner: false
            }, function () {
              if (priceMode === 'unit') {
                _this.changePriceUnit(priceMode);
              }
            });
          } else {
            chartData = {
              labels: labels,
              datasets: priceRangeDataset
            };
            this.setState({
              chartData: chartData,
              contracts: contracts,
              showSpinner: false
            });
          }

          return [2
          /*return*/
          , null];
        });
      });
    };

    _this.mergeCurrentSelectionWithPriceRangeDataset = function (currentSelectionQuantites, currentSelectionDatasets, priceRangeQuantites, priceRangeDataset, contracts) {
      var allQuantities = [];
      currentSelectionQuantites.forEach(function (quantity) {
        allQuantities.push(parseInt(quantity, 10)); // Adding current selection prices/null prices to PriceRangeDataset for current selection quantities.

        contracts.forEach(function (contract) {
          var normalizedContractName = contract.toLowerCase();
          var contractDataset = priceRangeDataset[normalizedContractName];
          contractDataset.current.data[quantity] = currentSelectionDatasets[normalizedContractName].data[quantity];
          contractDataset.current.currency[quantity] = currentSelectionDatasets[normalizedContractName].currency[quantity];

          if (!contractDataset.minmax.data[quantity]) {
            contractDataset.minmax.data[quantity] = [null, null];
            contractDataset.minmax.currency[quantity] = null;
          }

          if (!contractDataset.minimum.data[quantity]) {
            contractDataset.minimum.data[quantity] = null;
            contractDataset.minimum.currency[quantity] = null;
          }

          if (!contractDataset.maximum.data[quantity]) {
            contractDataset.maximum.data[quantity] = null;
            contractDataset.maximum.currency[quantity] = null;
          }
        });
      }); // Adding PriceRange dataset quantities to current selection dataset

      priceRangeQuantites.forEach(function (quantity) {
        allQuantities.push(parseInt(quantity, 10));
        contracts.forEach(function (contract) {
          var normalizedContractName = contract.toLowerCase();
          var contractDataset = priceRangeDataset[normalizedContractName];

          if (!contractDataset.current.data[quantity]) {
            contractDataset.current.data[quantity] = null;
            contractDataset.current.currency[quantity] = null;
          }

          if (!contractDataset.minimum.data[quantity]) {
            contractDataset.minimum.data[quantity] = null;
            contractDataset.minimum.currency[quantity] = null;
          }

          if (!contractDataset.maximum.data[quantity]) {
            contractDataset.maximum.data[quantity] = null;
            contractDataset.maximum.currency[quantity] = null;
          }
        });
      }); // Converting map to array for graphs

      contracts.forEach(function (contract) {
        var normalizedContractName = contract.toLowerCase();
        var contractDataset = priceRangeDataset[normalizedContractName];
        contractDataset.minmax.data = Object.values(contractDataset.minmax.data);
        contractDataset.minmax.currency = Object.values(contractDataset.minmax.currency);
        contractDataset.minimum.data = Object.values(contractDataset.minimum.data);
        contractDataset.minimum.currency = Object.values(contractDataset.minimum.currency);
        contractDataset.maximum.data = Object.values(contractDataset.maximum.data);
        contractDataset.maximum.currency = Object.values(contractDataset.maximum.currency);
        contractDataset.current.data = Object.values(contractDataset.current.data);
        contractDataset.current.currency = Object.values(contractDataset.current.currency);
      });
      allQuantities = new Set(allQuantities);
      allQuantities = Array.from(allQuantities).sort(sortArrayCompareFunction);
      return allQuantities;
    };

    _this.insertPrices = function (data, quantity, datasets, pivotKeyColumn, contracts, displayPrice, currency) {
      var header = data.split('|').filter(function (head) {
        return head !== '';
      });
      var contractName = header.pop();
      var contractType = header.pop();
      var normalizedContractName = contractName && contractName.toLowerCase();

      if (!normalizedContractName || !datasets[normalizedContractName]) {
        return null;
      }

      if (!contracts[contractName]) {
        contracts[contractName] = {
          type: contractType,
          label: contractName
        };
      }

      datasets[normalizedContractName].data[quantity] = displayPrice;
      datasets[normalizedContractName].currency[quantity] = currency;
      return null;
    };

    _this.sortContracts = function (contracts) {
      var filteredContracts = {};
      filteredContracts.CatalogPrice = [];
      filteredContracts.Contracts = [];
      contracts.forEach(function (contract) {
        if (contract.type === 'Catalog Price') {
          filteredContracts.CatalogPrice.push(contract.label);
        } else {
          filteredContracts.Contracts.push(contract.label);
        }
      });
      return filteredContracts;
    };

    _this.onChartTypeChange = function (event) {
      _this.setState({
        priceAnalysisChartType: event.target.value
      });
    };

    _this.changeDisplayedContract = function (contract) {
      var chartData = _this.state.chartData;
      var priceMode = _this.props.priceMode;

      var result = _this.filterChartDatafromDataset(chartData, contract);

      if (result) {
        var areaChartData = result.areaChartData,
            barChartData = result.barChartData;

        _this.setState({
          areaChartData: areaChartData,
          barChartData: barChartData
        }, function () {
          if (priceMode === 'unit') {
            _this.changePriceUnit(priceMode);
          }
        });
      }
    };

    _this.onContractChange = function (event) {
      _this.setState({
        selectedContract: event.target.value
      });

      _this.changeDisplayedContract(event.target.value);
    };

    _this.chartReference = React.createRef();
    _this.state = _this.getInitialState();
    return _this;
  }

  PriceAnalysis.prototype.componentWillMount = function () {
    this.populateGraphData();
  };

  PriceAnalysis.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
    var _this = this;

    if (JSON.stringify(prevProps.gridData) !== JSON.stringify(this.props.gridData) || JSON.stringify(prevProps.headers) !== JSON.stringify(this.props.headers) || prevProps.priceMode !== this.props.priceMode || prevProps.currency !== this.props.currency) {
      this.setState({
        areaChartData: null,
        chartData: null,
        barChartData: null,
        contracts: null,
        showSpinner: true
      }, function () {
        return _this.populateGraphData();
      });
    }
  };

  PriceAnalysis.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        priceMode = _a.priceMode,
        pivotKeyColumn = _a.pivotKeyColumn;
    var _b = this.state,
        chartData = _b.chartData,
        contracts = _b.contracts,
        selectedContract = _b.selectedContract,
        priceAnalysisChartType = _b.priceAnalysisChartType,
        areaChartData = _b.areaChartData,
        barChartData = _b.barChartData,
        showSpinner = _b.showSpinner;
    var Spinner = shapes.Spinner;
    var areaChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      spanGaps: true,
      title: {
        display: true,
        text: 'Price Analysis'
      },
      tooltips: {
        mode: 'label',
        callbacks: {
          title: function title(tooltipItem, data) {
            return "Quantity: " + data.labels[tooltipItem[0].index];
          },
          label: function label(tooltipItems, data) {
            return data.datasets[tooltipItems.datasetIndex].label + ": " + tooltipItems.yLabel.toLocaleString(undefined, {
              style: 'currency',
              currency: data.datasets[tooltipItems.datasetIndex].currency[tooltipItems.index]
            });
          }
        }
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
      scales: {
        xAxes: [{
          display: true,
          scaleLabel: {
            display: true,
            labelString: 'Quantity'
          },
          ticks: {
            callback: function callback(title) {
              var maxLabelLength = 15;
              if (title.length > maxLabelLength) return title.substr(0, maxLabelLength) + "...";
              return title;
            }
          }
        }],
        yAxes: [{
          display: true,
          scaleLabel: {
            display: true,
            labelString: priceMode === 'total' ? 'Total Price' : 'Price per Item'
          }
        }]
      },
      pan: {
        enabled: true,
        mode: 'xy',
        rangeMin: {
          x: 0,
          y: 0
        }
      },
      zoom: {
        enabled: true,
        mode: 'xy',
        rangeMin: {
          x: 0,
          y: 0
        },
        speed: 0.05
      }
    };
    var barChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      spanGaps: true,
      title: {
        display: true,
        text: 'Price Analysis'
      },
      tooltips: {
        mode: 'label',
        callbacks: {
          title: function title(tooltipItem, data) {
            return "Quantity: " + data.labels[tooltipItem[0].index];
          },
          label: function label(tooltipItems, data) {
            if (tooltipItems.datasetIndex !== 0) {
              return data.datasets[tooltipItems.datasetIndex].label + ": " + tooltipItems.yLabel.toLocaleString(undefined, {
                style: 'currency',
                currency: data.datasets[tooltipItems.datasetIndex].currency[tooltipItems.index]
              });
            } // eslint-disable-next-line no-useless-escape


            var t = tooltipItems.yLabel.replace(/[\[\] ]/g, '').split(',');
            var min = t[0];
            var max = t[1];
            var displayedText;

            if (min !== 'NaN') {
              displayedText = "Minimum: " + parseFloat(min).toLocaleString(undefined, {
                style: 'currency',
                currency: data.datasets[tooltipItems.datasetIndex].currency[tooltipItems.index]
              });
            }

            if (max !== 'NaN') {
              displayedText = displayedText + "\nMaximum: " + parseFloat(max).toLocaleString(undefined, {
                style: 'currency',
                currency: data.datasets[tooltipItems.datasetIndex].currency[tooltipItems.index]
              });
            }

            return displayedText || null;
          }
        }
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
      scales: {
        xAxes: [{
          display: true,
          scaleLabel: {
            display: true,
            labelString: 'Quantity'
          },
          ticks: {
            callback: function callback(title) {
              var maxLabelLength = 15;
              if (title.length > maxLabelLength) return title.substr(0, maxLabelLength) + "...";
              return title;
            }
          }
        }],
        yAxes: [{
          display: true,
          scaleLabel: {
            display: true,
            labelString: priceMode === 'total' ? 'Total Price' : 'Price per Item'
          }
        }]
      },
      pan: {
        enabled: true,
        mode: 'xy',
        rangeMin: {
          x: 0,
          y: 0
        }
      },
      zoom: {
        enabled: true,
        mode: 'xy',
        rangeMin: {
          x: 0,
          y: 0
        },
        speed: 0.05
      }
    };
    var chartSelectionDropdown = React.createElement("div", {
      className: "price-analysis-chart-selection-dropdown"
    }, React.createElement(FormControl, null, React.createElement(InputLabel, {
      id: "demo-simple-select-label",
      className: "price-analysis-chart-selection-dropdown-label"
    }, "Select Chart"), React.createElement(Select, {
      labelId: "demo-simple-select-label",
      id: "demo-simple-select",
      className: "price-analysis-chart-selection-dropdown-select",
      value: priceAnalysisChartType,
      onChange: this.onChartTypeChange
    }, React.createElement(MenuItem, {
      className: "price-analysis-chart-type-dropdown-item",
      value: "bar"
    }, "Bar"), React.createElement(MenuItem, {
      className: "price-analysis-chart-type-dropdown-item",
      value: "area"
    }, "Area"))));
    var contractSelectionDropdown = contracts && React.createElement("div", {
      className: "price-analysis-contracts-dropdown"
    }, React.createElement(FormControl, null, React.createElement(InputLabel, {
      id: "demo-simple-select-label",
      className: "price-analysis-contracts-dropdown-label"
    }, "Select Contract"), React.createElement(Select, {
      labelId: "demo-simple-select-label",
      id: "demo-simple-select",
      className: "price-analysis-contracts-dropdown-select",
      value: selectedContract,
      onChange: this.onContractChange
    }, contracts.map(function (contract) {
      return React.createElement(MenuItem, {
        className: "price-analysis-contracts-dropdown-item",
        value: contract,
        key: contract
      }, contract);
    }))));
    var currentChart = priceAnalysisChartType === 'area' ? React.createElement(Line, {
      ref: this.chartReference,
      redraw: true,
      data: areaChartData,
      options: areaChartOptions
    }) : React.createElement(Bar, {
      ref: this.chartReference,
      redraw: true,
      data: barChartData,
      options: barChartOptions
    });
    var backButton = React.createElement("div", {
      className: "price-analysis-button"
    }, React.createElement("a", {
      onClick: function onClick() {
        _this.props.togglePriceAnalysis();
      }
    }, "Back"));

    if (!chartData || chartData.datasets.length === 0 || pivotKeyColumn) {
      if (showSpinner) {
        return React.createElement(Spinner, {
          className: "flex-center spinner-div"
        });
      }

      return React.createElement("div", null, React.createElement("div", {
        className: "empty-charts-nav-header-group"
      }, backButton), React.createElement("div", {
        className: "price-analysis-chart-div"
      }, emptyChart));
    }

    return React.createElement("div", null, React.createElement("div", {
      className: "charts-nav-header-group"
    }, React.createElement("div", {
      className: "price-analysis-dropdown-group"
    }, chartSelectionDropdown, contractSelectionDropdown), backButton), React.createElement("div", {
      className: "price-analysis-chart-div"
    }, currentChart), React.createElement(Button, {
      type: "default",
      size: "sm",
      className: "reset-zoom-button",
      onClick: function onClick() {
        return _this.chartReference.current.chartInstance.resetZoom();
      }
    }, "Reset Zoom"));
  };

  return PriceAnalysis;
}(Component);

export default PriceAnalysis;